"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExecuteSaleRemainingAccountsInstruction = exports.executeSaleRemainingAccountsInstructionDiscriminator = exports.executeSaleRemainingAccountsStruct = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
exports.executeSaleRemainingAccountsStruct = new beet.BeetArgsStruct([['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)]], 'ExecuteSaleRemainingAccountsInstructionArgs');
exports.executeSaleRemainingAccountsInstructionDiscriminator = [
    159, 12, 171, 254, 141, 198, 122, 7,
];
function createExecuteSaleRemainingAccountsInstruction(accounts, programId = new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk')) {
    const [data] = exports.executeSaleRemainingAccountsStruct.serialize({
        instructionDiscriminator: exports.executeSaleRemainingAccountsInstructionDiscriminator,
    });
    const keys = [
        {
            pubkey: accounts.metadataProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.edition,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.ownerTr,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.destinationTr,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.authRulesProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.authRules,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.sysvarInstructions,
            isWritable: false,
            isSigner: false,
        },
    ];
    if (accounts.anchorRemainingAccounts != null) {
        for (const acc of accounts.anchorRemainingAccounts) {
            keys.push(acc);
        }
    }
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createExecuteSaleRemainingAccountsInstruction = createExecuteSaleRemainingAccountsInstruction;
//# sourceMappingURL=executeSaleRemainingAccounts.js.map